export const formatDateParam = (date) => {
  if (!date) return "";
  const [dd, mm, yyyy] = date.split("-");
  if (!dd || !mm || !yyyy) return "";
  return `${dd}/${mm}/${yyyy}`;
};

export const buildReportTableSection = (tableHTML) =>
  tableHTML ? `<div class="report-table-section">${tableHTML}</div>` : "";

export const toBase64FromPublic = async (path) => {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image to base64:", error);
    return "";
  }
};

export const generateChartImage = async (
  data,
  title,
  totalLabel = "Tổng số",
  totalFormatter = (v) => v.toLocaleString()
) => {
  if (!data || data.length === 0) return "";

  const canvas = document.createElement("canvas");
  canvas.width = 800;
  canvas.height = 400;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const chartCenterX = 200;
  const chartCenterY = 200;
  const radius = 140;

  const normalizedData = data.map((item) => ({
    name: item.name || item.label || item.statusName || "N/A",
    value: parseFloat(item.value || item.count || item.amount || 0),
  }));

  const total = normalizedData.reduce((sum, item) => sum + item.value, 0);

  if (total === 0) return "";

  const colors = [
    "#2563EB", "#10B981", "#F97316", "#EF4444", "#8B5CF6",
    "#0EA5E9", "#F59E0B", "#EC4899", "#14B8A6", "#84CC16",
    "#6366F1", "#A855F7",
  ];

  let startAngle = -Math.PI / 2;

  ctx.save();
  ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
  ctx.shadowBlur = 15;
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 4;

  normalizedData.forEach((item, index) => {
    const value = item.value;
    const sliceAngle = (value / total) * Math.PI * 2;
    const endAngle = startAngle + sliceAngle;

    const gradient = ctx.createRadialGradient(
      chartCenterX,
      chartCenterY,
      0,
      chartCenterX,
      chartCenterY,
      radius,
    );
    const baseColor = colors[index % colors.length];
    gradient.addColorStop(0, baseColor);
    gradient.addColorStop(1, baseColor + "DD");

    ctx.beginPath();
    ctx.moveTo(chartCenterX, chartCenterY);
    ctx.arc(chartCenterX, chartCenterY, radius, startAngle, endAngle);
    ctx.closePath();
    ctx.fillStyle = gradient;
    ctx.fill();

    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 3;
    ctx.stroke();

    startAngle = endAngle;
  });

  ctx.restore();

  ctx.beginPath();
  ctx.arc(chartCenterX, chartCenterY, radius * 0.6, 0, Math.PI * 2);
  ctx.fillStyle = "#ffffff";
  ctx.fill();

  ctx.textAlign = "center";
  ctx.fillStyle = "#6B7280";
  ctx.font = "400 16px Inter, Arial, sans-serif";
  ctx.fillText(totalLabel, chartCenterX, chartCenterY - 10);

  ctx.fillStyle = "#111827";
  ctx.font = "600 24px Inter, Arial, sans-serif";
  ctx.fillText(totalFormatter(total), chartCenterX, chartCenterY + 25);

  const legendX = 420;
  const lineHeight = 38;
  const totalLegendHeight = normalizedData.length * lineHeight;
  let legendY = chartCenterY - totalLegendHeight / 2 + 10;

  ctx.textAlign = "left";

  normalizedData.forEach((item, index) => {
    const value = item.value;
    const percentage = ((value / total) * 100).toFixed(1);
    const name = item.name;

    ctx.save();
    ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 2;

    ctx.fillStyle = colors[index % colors.length];
    ctx.fillRect(legendX, legendY - 10, 16, 16);
    ctx.restore();

    ctx.strokeStyle = "#E5E7EB";
    ctx.lineWidth = 1;
    ctx.strokeRect(legendX, legendY - 10, 16, 16);

    ctx.fillStyle = "#1F2937";
    ctx.font = "600 14px Inter, Arial, sans-serif";
    ctx.fillText(name, legendX + 24, legendY);

    ctx.font = "400 12px Inter, Arial, sans-serif";
    ctx.fillStyle = "#6B7280";
    ctx.fillText(
      `${totalFormatter(value)} (${percentage}%)`,
      legendX + 24,
      legendY + 16,
    );

    legendY += lineHeight;
  });

  ctx.fillStyle = "#111827";
  ctx.font = "600 16px Inter, Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText(title, canvas.width / 2, 25);

  return canvas.toDataURL("image/png");
};

export const buildPrintHTML = (bodyHTML, title = "Báo cáo") => {
  return `<!doctype html>
<html lang="vi">
<head>
  <meta charset="utf-8"/>
  <title>${title}</title>
  <style>
    :root{--page-w:1123px;--page-h:794px;}
    *{box-sizing:border-box;margin:0;padding:0}
    html,body{background:#fff;color:#111;font-family:Inter,system-ui}
    @page{size:1123px 794px;margin:42px 40px 58px 40px}
    body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
    .pdf-root{width:100%;line-height:1.45;font-size:13px}
    table{width:100%;border-collapse:collapse;font-size:12px;margin-top:12px;table-layout:fixed}
    th,td{border:1px solid #d1d5db;padding:8px;word-break:break-word}
    thead{background:#e5e7eb;display:table-header-group}
    .wm-overlay-fixed{
      position:fixed;
      width:100%;
      height:100%;
      top:0;left:0;
      background-size:contain;
      background-repeat:no-repeat;
      background-position:center;
      opacity:0.12;
      pointer-events:none;
      z-index:999999;
    }
    .heading{
      text-align:center;
      font-size:22px;
      font-weight:600;
      color:#0457C2;
      padding-bottom:10px;
      margin-bottom:16px;
      page-break-after:avoid;
    }
    .section-title{
      font-size:18px;
      font-weight:600;
      color:#0457C2;
      margin-top:30px;
      margin-bottom:12px;
      padding-bottom:8px;
      border-bottom:1px solid #E5E7EB;
      page-break-after:avoid;
    }
    .chart-container{
      text-align:center;
      margin:16px 0;
      page-break-inside:avoid;
    }
    .chart-container img{
      max-width:100%;
      max-height:350px;
      height:auto;
      border-radius:8px;
      padding:10px;
      background:#fff;
      object-fit:contain;
    }
    .report-section{
      page-break-inside:avoid;
      display:block;
      width:100%;
      margin-bottom: 20px;
    }
    .summary-box{
      display:inline-block;
      margin:0 10px 10px 0;
      padding:8px 12px;
      background:#f8fafc;
      border:1px solid #e5e7eb;
      border-radius:8px;
    }
    .overview-summary-grid{
      display:grid;
      grid-template-columns:repeat(3,minmax(0,1fr));
      gap:12px;
      margin-bottom:14px;
    }
    .overview-summary-card{
      border:1px solid #e5e7eb;
      border-radius:8px;
      padding:10px 12px;
      background:#f8fafc;
      page-break-inside:avoid;
    }
    .overview-summary-card h3{
      color:#0457C2;
      font-size:14px;
      margin-bottom:8px;
    }
    .overview-summary-card p{
      margin:4px 0;
    }
    .overview-chart-grid{
      display:grid;
      grid-template-columns:repeat(3,minmax(0,1fr));
      gap:12px;
      align-items:start;
    }
    .overview-chart-card{
      border:1px solid #e5e7eb;
      border-radius:8px;
      padding:8px;
      background:#fff;
      page-break-inside:avoid;
    }
    .overview-chart-card h3{
      color:#111827;
      font-size:13px;
      text-align:center;
      margin-bottom:6px;
    }
    .overview-chart-card img{
      width:100%;
      max-height:205px;
      object-fit:contain;
      display:block;
    }
    .report-table-section{
      page-break-before:always;
      break-before:page;
      page-break-inside:auto;
      break-inside:auto;
      width:100%;
    }
    table{
      page-break-inside:auto;
      break-inside:auto;
    }
    tr {
      page-break-inside:avoid;
      break-inside:avoid;
    }
    .report-footer{
      position:fixed;
      left:40px;
      right:40px;
      bottom:18px;
      text-align:center;
      font-size:10.5px;
      line-height:1.35;
      color:#4b5563;
    }
  </style>
</head>
<body>
  <div class="wm-overlay-fixed"></div>
  <div class="pdf-root">
    ${bodyHTML}
  </div>
  <div class="report-footer">
    <p>Báo cáo được tổng hợp vào ngày ${new Date().toLocaleDateString("vi-VN")} từ Nền tảng số Sohuutritue.vn</p>
    <p>Tổng đài tư vấn Sở hữu trí tuệ: 08 1900 9697 (điện thoại, zalo) – Email: luatsu@sohuutritue.vn</p>
  </div>
</body>
</html>`;
};

